(function () {
  'use strict';

  var CART_BAR_SELECTOR = '#cart-bar';
  var OFFSET_GAP = 16;
  var WIDGET_SELECTOR = [
    '[id*="chatty"]',
    '[id*="Chatty"]',
    '[class*="chatty"]',
    '[class*="Chatty"]',
    '[id*="avada"]',
    '[id*="AVADA"]',
    '[class*="avada"]',
    '[class*="AVADA"]',
    '[id*="chatbox"]',
    '[id*="chatBox"]',
    '[class*="chatbox"]',
    '[class*="chatBox"]',
    '[id*="chat-box"]',
    '[class*="chat-box"]'
  ].join(',');

  var adjustedWidgets = new WeakMap();
  var adjustedWidgetSet = new Set();
  var updateFrame = null;
  var pageObserver = null;
  var cartBarObserver = null;

  function scheduleUpdate() {
    if (updateFrame) {
      return;
    }

    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = null;
      updateChattyPosition();
    });
  }

  function getFixedWidget(element) {
    var node = element;

    while (node && node !== document.body && node !== document.documentElement) {
      var styles = window.getComputedStyle(node);

      if (styles.position === 'fixed' || styles.position === 'sticky') {
        return node;
      }

      node = node.parentElement;
    }

    return null;
  }

  function isBottomAnchored(element) {
    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    var nearViewportBottom = rect.bottom > window.innerHeight - 240;

    return styles.bottom !== 'auto' || nearViewportBottom;
  }

  function isCompactLauncher(element) {
    var rect = element.getBoundingClientRect();

    return rect.width > 0 && rect.height > 0 && rect.width <= 160 && rect.height <= 160;
  }

  function getChattyWidgets(cartBar) {
    var widgets = [];
    var seen = new WeakSet();
    var matches = document.querySelectorAll(WIDGET_SELECTOR);

    matches.forEach(function (match) {
      var widget = getFixedWidget(match);

      if (!widget || seen.has(widget) || widget === cartBar || widget.contains(cartBar) || cartBar.contains(widget)) {
        return;
      }

      if (!isBottomAnchored(widget)) {
        return;
      }

      if (!isCompactLauncher(widget)) {
        restoreWidget(widget);
        return;
      }

      seen.add(widget);
      widgets.push(widget);
    });

    return widgets;
  }

  function offsetWidget(widget, offset) {
    if (!adjustedWidgets.has(widget)) {
      var initialStyles = window.getComputedStyle(widget);
      var baseBottom = widget.style.bottom || initialStyles.bottom;

      if (!baseBottom || baseBottom === 'auto') {
        baseBottom = '0px';
      }

      adjustedWidgets.set(widget, {
        bottom: widget.style.bottom,
        priority: widget.style.getPropertyPriority('bottom'),
        baseBottom: baseBottom
      });
    }

    var saved = adjustedWidgets.get(widget);

    widget.style.setProperty('bottom', 'calc(' + saved.baseBottom + ' + ' + offset + 'px)', 'important');
    widget.setAttribute('data-jd-chatty-cart-offset', 'true');
    adjustedWidgetSet.add(widget);
  }

  function restoreWidget(widget) {
    var saved = adjustedWidgets.get(widget);

    if (!saved) {
      return;
    }

    if (saved.bottom) {
      widget.style.setProperty('bottom', saved.bottom, saved.priority);
    } else {
      widget.style.removeProperty('bottom');
    }

    widget.removeAttribute('data-jd-chatty-cart-offset');
    adjustedWidgets.delete(widget);
    adjustedWidgetSet.delete(widget);
  }

  function restoreAdjustedWidgetsExcept(widgets) {
    var keep = new Set(widgets);

    Array.from(adjustedWidgetSet).forEach(function (widget) {
      if (!keep.has(widget)) {
        restoreWidget(widget);
      }
    });
  }

  function updateChattyPosition() {
    var cartBar = document.querySelector(CART_BAR_SELECTOR);

    if (!cartBar) {
      return;
    }

    var cartBarVisible = cartBar.classList.contains('is-visible');
    var offset = Math.ceil(cartBar.getBoundingClientRect().height + OFFSET_GAP);
    var widgets = getChattyWidgets(cartBar);

    document.body.classList.toggle('jd-cart-bar-visible', cartBarVisible);

    restoreAdjustedWidgetsExcept(cartBarVisible ? widgets : []);

    widgets.forEach(function (widget) {
      if (cartBarVisible) {
        offsetWidget(widget, offset);
      } else {
        restoreWidget(widget);
      }
    });
  }

  function observeCartBar(cartBar) {
    if (cartBarObserver) {
      cartBarObserver.disconnect();
    }

    cartBarObserver = new MutationObserver(scheduleUpdate);
    cartBarObserver.observe(cartBar, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function init() {
    var cartBar = document.querySelector(CART_BAR_SELECTOR);

    if (!cartBar) {
      return;
    }

    observeCartBar(cartBar);

    pageObserver = new MutationObserver(scheduleUpdate);
    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('theme:scroll', scheduleUpdate);
    document.addEventListener('theme:resize', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);

    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
